import {
  DesriptionTitle,
  DescriptionListItem,
  DescriptionList,
} from '../AudioCall/AudioCallDescription'

export const SprintDescription = () => (
  <>
    <DesriptionTitle>«Спринт»</DesriptionTitle>
    <DescriptionList>
      Тренировка на скорость. Угадай как можно больше слов за 30 секунд
      <DescriptionListItem>Используйте мышь, чтобы выбрать</DescriptionListItem>
      <DescriptionListItem>
        Используйте клавиши от ArrowLeft и ArrowRight для выбора ответа
      </DescriptionListItem>
    </DescriptionList>
  </>
)
